/**
 * Updates values of the lobby.lobbyConfig store object
 * @param  {any?} [value] A complete lobbyConfig item to save to local storage
 *                        and to the redux store.
 *
 */
export function updateLobbyConfig(value) {
  return {
    type: 'UPDATE_LOBBY_CONFIG',
    value
  }
}
